module.exports = __webpack_public_path__ + "static/media/tunnel.a4b9c876.svg";